export const categories = [
  {
    id: 'enterprise',
    label: {
      zh: '企业产品',
      en: 'Enterprise',
      es: 'Empresas',
      fr: 'Entreprise',
      ja: 'エンタープライズ',
    },
    desc: {
      zh: '面向中型组织的数据治理与私有化交付方案。',
      en: 'Data governance solutions for mid-size organizations.',
      es: 'Soluciones de gobernanza de datos para organizaciones medianas.',
      fr: 'Solutions de gouvernance des données pour organisations de taille moyenne.',
      ja: '中規模組織向けデータガバナンスとプライベート導入。',
    },
    accent: 'slate',
    products: [
      {
        id: 'data-platform',
        name: 'Beiyi Data Platform',
        nameZh: '贝易数据产品',
        tagline: {
          zh: '企业级数据治理，支持私有化部署。',
          en: 'Enterprise data governance on your own infrastructure.',
          es: 'Gobernanza de datos empresarial en su propia infraestructura.',
          fr: "Gouvernance des données d'entreprise sur votre infrastructure.",
          ja: '自社基盤で運用できるエンタープライズ向けデータガバナンス。',
        },
        desc: {
          zh: '覆盖数据资产管理、质量治理与元数据管理，支持源码授权与私有化交付。',
          en: 'Covers data asset, quality, and metadata management with source licensing and private deployment.',
          es: 'Cubre activos de datos, calidad y metadatos, con licencia de código y despliegue privado.',
          fr: 'Couvre actifs, qualité et métadonnées, avec licence source et déploiement privé.',
          ja: 'データ資産・品質・メタデータ管理をカバーし、ソース提供と私有化導入に対応。',
        },
        badge: {
          zh: '私有部署',
          en: 'Private Deploy',
          es: 'Despliegue Privado',
          fr: 'Déploiement Privé',
          ja: 'プライベート導入',
        },
        coverType: 'image',
        coverUrl: '/pipeline.png',
        accentColor: '#94a3b8',
        links: [
          {
            label: {
              zh: '查看产品',
              en: 'View Product',
              es: 'Ver producto',
              fr: 'Voir le produit',
              ja: '製品を見る',
            },
            url: 'https://beiyidata.cn/dp',
            primary: true,
          },
          {
            label: {
              zh: '联系销售',
              en: 'Contact Sales',
              es: 'Contactar ventas',
              fr: 'Contacter le service commercial',
              ja: '営業に連絡',
            },
            url: 'mailto:beibei@beiyidata.cn',
            primary: false,
          },
        ],
      },
    ],
  },
  {
    id: 'ai-tools',
    label: {
      zh: 'AI 工具',
      en: 'AI Tools',
      es: 'Herramientas de IA',
      fr: "Outils d'IA",
      ja: 'AIツール',
    },
    desc: {
      zh: '面向开发者与效率用户的 AI 工具与模型基础设施。',
      en: 'AI tools and model infrastructure for developers and power users.',
      es: 'Herramientas de IA e infraestructura de modelos para desarrolladores y usuarios avanzados.',
      fr: "Outils d'IA et infrastructure de modèles pour développeurs et utilisateurs avancés.",
      ja: '開発者とパワーユーザー向けのAIツールとモデル基盤。',
    },
    accent: 'amber',
    products: [
      {
        id: 'pagepilot',
        name: 'PagePilot',
        tagline: {
          zh: '更轻更快的 AI 浏览器助手，价格仅主流方案约 1/10。',
          en: 'A lightweight AI browser assistant at around 1/10 mainstream pricing.',
          es: 'Asistente de navegador con IA, ligero y rápido, por ~1/10 del precio habitual.',
          fr: "Assistant navigateur IA léger et rapide, à ~1/10 du prix des solutions courantes.",
          ja: '軽量で高速なAIブラウザアシスタント。主要サービスの約1/10価格。',
        },
        desc: {
          zh: '支持网页问答、划词解释、整页总结、翻译与智能阅读，适合高频信息处理场景。',
          en: 'Supports page Q&A, highlight explainers, full-page summaries, translation, and smart reading.',
          es: 'Incluye preguntas sobre páginas, explicación de texto resaltado, resúmenes, traducción y lectura inteligente.',
          fr: 'Inclut Q&A sur page web, explication de sélection, résumé complet, traduction et lecture intelligente.',
          ja: 'ページQ&A、選択テキスト解説、全文要約、翻訳、スマートリーディングに対応。',
        },
        badge: {
          zh: 'Chrome 扩展',
          en: 'Chrome Extension',
          es: 'Extensión de Chrome',
          fr: 'Extension Chrome',
          ja: 'Chrome拡張',
        },
        coverType: 'gradient',
        coverGradient: 'from-[#0f1a2e] to-[#1a2a1a]',
        accentColor: '#e8c96a',
        features: {
          zh: ['网页问答', '智能填表', '整页总结', '智能翻译'],
          en: ['Page Q&A', 'Smart autofill', 'Full-page summary', 'AI translation'],
          es: ['Q&A de página', 'Autocompletar inteligente', 'Resumen completo', 'Traducción IA'],
          fr: ['Q&A de page', 'Auto-remplissage intelligent', 'Résumé complet', 'Traduction IA'],
          ja: ['ページQ&A', 'スマート入力補完', '全文要約', 'AI翻訳'],
        },
        links: [
          {
            label: {
              zh: '获取扩展',
              en: 'Get Extension',
              es: 'Instalar extensión',
              fr: "Installer l'extension",
              ja: '拡張機能を入手',
            },
            url: 'https://beiyidata.cn/pagepilot',
            primary: true,
          },
        ],
      },
    ],
  },
  {
    id: 'consumer',
    label: {
      zh: '消费者应用',
      en: 'Consumer Apps',
      es: 'Apps de Consumo',
      fr: 'Applications Grand Public',
      ja: 'コンシューマー向けアプリ',
    },
    desc: {
      zh: '面向日常生活的移动应用，强调体验与长期使用。',
      en: 'Mobile apps for daily life, designed for long-term use.',
      es: 'Aplicaciones móviles para la vida diaria, diseñadas para uso continuo.',
      fr: 'Applications mobiles du quotidien, conçues pour un usage durable.',
      ja: '日常生活向けのモバイルアプリ。長期利用を重視。',
    },
    accent: 'blue',
    products: [
      {
        id: 'beibei-budget',
        name: 'Beibei Budget',
        nameZh: '贝贝记账',
        tagline: {
          zh: '简单好用的个人与家庭记账工具。',
          en: 'Simple personal and family budgeting.',
          es: 'Finanzas personales y familiares, simples.',
          fr: 'Gestion budgétaire personnelle et familiale simplifiée.',
          ja: '個人・家計向けのシンプルな家計簿アプリ。',
        },
        desc: {
          zh: '支持语音记账、账单导入、AI 财务分析、共享账本与预算跟踪。',
          en: 'Includes voice logging, bill import, AI analysis, shared ledgers, and budget tracking.',
          es: 'Incluye registro por voz, importación de facturas, análisis IA y presupuesto compartido.',
          fr: "Inclut saisie vocale, import de relevés, analyse IA et suivi budgétaire partagé.",
          ja: '音声記帳、明細インポート、AI分析、共有台帳、予算トラッキングに対応。',
        },
        badge: {
          zh: 'iOS · 免费',
          en: 'iOS · Free',
          es: 'iOS · Gratis',
          fr: 'iOS · Gratuit',
          ja: 'iOS・無料',
        },
        coverType: 'image',
        coverUrl:
          'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/a7/f2/18/a7f21889-1d36-16fa-9350-a640e33cf5d9/Placeholder.mill/1200x630wa.jpg',
        accentColor: '#60a5fa',
        officialUrl: 'https://beiyidata.cn/beibeibudget',
        links: [
          {
            label: {
              zh: 'App Store',
              en: 'App Store',
              es: 'App Store',
              fr: 'App Store',
              ja: 'App Store',
            },
            url: 'https://apps.apple.com/us/app/%E8%B4%9D%E8%B4%9D%E8%AE%B0%E8%B4%A6/id6755133153',
            primary: true,
          },
          {
            label: {
              zh: '官网',
              en: 'Website',
              es: 'Sitio web',
              fr: 'Site web',
              ja: '公式サイト',
            },
            url: 'https://beiyidata.cn/beibeibudget',
            primary: false,
          },
        ],
      },
      {
        id: 'nomi',
        name: 'Nomi',
        tagline: {
          zh: '先理解你的状态，再陪你安排任务节奏。',
          en: 'Reads your state first, then supports your rhythm.',
          es: 'Primero entiende tu estado, luego te ayuda con tu ritmo.',
          fr: "Comprend d'abord votre état, puis accompagne votre rythme.",
          ja: 'まず状態を理解し、その上でタスクのリズムを支援。',
        },
        desc: {
          zh: '关注情绪、能量与任务压力，提供更贴合当下状态的支持建议。',
          en: 'Tracks mood, energy, and task pressure to provide context-aware support.',
          es: 'Monitorea ánimo, energía y presión de tareas para ofrecer apoyo contextual.',
          fr: "Suit l'humeur, l'énergie et la pression pour proposer un accompagnement contextualisé.",
          ja: '気分・エネルギー・タスク負荷を捉え、状況に合うサポートを提供。',
        },
        badge: {
          zh: 'iOS · 免费',
          en: 'iOS · Free',
          es: 'iOS · Gratis',
          fr: 'iOS · Gratuit',
          ja: 'iOS・無料',
        },
        coverType: 'image',
        coverUrl:
          'https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/cb/5c/aa/cb5caa84-9953-a57e-15b1-98d6346f05fa/Placeholder.mill/1200x630wa.jpg',
        accentColor: '#60a5fa',
        officialUrl: 'https://beiyidata.cn/nomi',
        links: [
          {
            label: {
              zh: 'App Store',
              en: 'App Store',
              es: 'App Store',
              fr: 'App Store',
              ja: 'App Store',
            },
            url: 'https://apps.apple.com/us/app/nomi/id6761092206',
            primary: true,
          },
          {
            label: {
              zh: '官网',
              en: 'Website',
              es: 'Sitio web',
              fr: 'Site web',
              ja: '公式サイト',
            },
            url: 'https://beiyidata.cn/nomi',
            primary: false,
          },
        ],
      },
    ],
  },
]
